// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PlanInfo_wrap__3M2Ys","header":"PlanInfo_header__3aYkO","info":"PlanInfo_info__2o51Z"};